import React, { useEffect, useState } from 'react'
import { Box, Button, Grid, IconButton, Pagination, Stack, Typography, useTheme, } from '@mui/material';
import ScrollBox from '../../../components/ScrollBox';
import SwapVertOutlinedIcon from '@mui/icons-material/SwapVertOutlined';
import SearchTxtField from '../../../components/SearchTxtField';
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { getAmtcCat, getAmtcProd } from '../../../services/amtc-service';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert } from '../../../components/notify';
import CatCard from '../../../components/CatCard';
import ProductCard from '../../../components/ProductCard';
import constants from '../../../utils/Constants';
import { Add } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import route from '../../../utils/Routes';



function AmtcCatalogPg() {
    const navigate = useNavigate();
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const theme = useTheme();
    const limit = 12;
    const [searchParams, setSearchParams] = useSearchParams();
    const prPageNumber = parseInt(searchParams.get("prPageNumber") || "1");
    const caPageNumber = parseInt(searchParams.get("caPageNumber") || "1");
    const querySearchWord = searchParams.get("s") || "";
    const isSrchRes = parseInt(searchParams.get("isSrchRes") || "0");
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
    const [caOrder, setCaOrder] = useState('desc');
    const { isLoading: isCatLoading, isError: isCatErr, error: catErr, data: catData } = useQuery([QueryKey.amtcCat, limit, caPageNumber, caOrder],
        () => getAmtcCat({ limit, pageNumber: caPageNumber, order: caOrder }), {
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    const { isLoading: isProdLoading, isError: isProdErr, error: prodErr, data: prodData } = useQuery([QueryKey.amtcProd, limit, prPageNumber, isSrchBtnClick],
        () => getAmtcProd({ limit, pageNumber: prPageNumber, searchKeyWord: searchWord }), {
        enabled: isSrchRes === 1,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    useEffect(() => {
        setLoadingScreen(isCatLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCatLoading]);

    useEffect(() => {
        setLoadingScreen(isProdLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isProdLoading]);


    async function onOrderChange(e) {
        if (caOrder === "desc")
            setCaOrder("asc");
        else
            setCaOrder("desc");
        // setCaPageNumber(1);
        setSearchParams(prev => {
            prev.set("caPageNumber", 1)
            return prev
        }, { replace: true })
    }


    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchParams(prev => {
            prev.set("prPageNumber", 1)
            prev.set("caPageNumber", 1)
            prev.set("isSrchRes", 1)
            return prev
        }, { replace: true })
    }

    function handleOnClear(e) {
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("prPageNumber", 1)
            prev.set("caPageNumber", 1)
            prev.set("s", "")
            prev.set("isSrchRes", 0)
            return prev
        }, { replace: true })
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    // function handleDDChange(e) {
    //     setSearchParams(prev => {
    //         prev.set("st", e.target.value)
    //         return prev
    //     }, { replace: true })
    // }

    function handleAddCatClick() {
        navigate(route.aCreateCat)
    }

    function handleCatCardClick(i) {
        navigate(`${route.aSubcategory}/?catId=${i?.id}&catName=${i?.catName}`)
    }

    const handlePrPageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("prPageNumber", value)
            return prev
        }, { replace: true })
    };

    const handleCaPageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("caPageNumber", value)
            return prev
        }, { replace: true })
    };


    if (isCatErr) {
        customAlert(catErr);
        return <h2>Something went wrong</h2>
    }

    if (isProdErr) {
        customAlert(prodErr);
        return <h2>Something went wrong</h2>
    }

    return (
        <Box height={"100%"} width={"100%"}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1 }} width={"100%"}>
                <Stack width={"33%"} >
                    <Typography sx={{ fontSize: 18, fontWeight: 500, }}> {isSrchRes === 1 ? "Product List" : "Product Categories"}</Typography>
                </Stack>
                <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={"33%"} >
                    <Box mb={0.5}><SearchTxtField handleOnClear={handleOnClear} variant={"outlined"} searchKeyWord={searchWord} width={400} onSearch={onSearch} onBtnClick={onSearchBtnClick}
                        placeholder={ctxtUser?.isComUser ? `Search Product By Name / AMTC ID / MAT Code / Desc / Manufacturer` : `Search Product By Name / AMTC ID / Desc / Manufacturer`} /></Box>
                </Stack>
                <Stack direction={"row"} justifyContent="end" alignItems={"center"} gap={2} width={"33%"} >
                    {ctxtUser?.userType === constants.admin && <Button variant='outlined' startIcon={<Add />} onClick={handleAddCatClick} sx={{
                        color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                    }}>
                        Create Category</Button>}
                    {isSrchRes === 1 ? <></> : <IconButton onClick={onOrderChange}>
                        <SwapVertOutlinedIcon />
                    </IconButton>}
                </Stack>
            </Stack>

            {isSrchRes === 1 ? <><ScrollBox height={"84%"}>
                <Grid container spacing={3}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    {(prodData?.prodsArr ?? []).map((i) => <Grid item xs="auto" key={i.id}>
                        <ProductCard i={i} key={i?.id} isComUser={ctxtUser?.isComUser} /> </Grid>)}
                </Grid>
            </ScrollBox>
                <Stack sx={{ alignItems: "center", mt: 1 }}>
                    <Pagination count={Math.ceil(prodData?.totalProdsCount / limit) || 0} color="primary" page={prPageNumber} onChange={handlePrPageChange} variant="outlined" shape="rounded" />
                </Stack>
            </> : <><ScrollBox height={"84%"}>
                <Grid container spacing={3}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    {(catData?.catsArr ?? []).map((i) => <Grid item xs="auto" key={i.id}>
                        <CatCard i={i} key={i?.id} handleClick={handleCatCardClick} /> </Grid>)}
                </Grid>
            </ScrollBox>
                <Stack sx={{ alignItems: "center", mt: 1 }}>
                    <Pagination count={Math.ceil(catData?.totalCatCount / limit) || 0} color="primary" page={caPageNumber} onChange={handleCaPageChange} variant="outlined" shape="rounded" />
                </Stack>
            </>}
        </Box>
    )
}
export default AmtcCatalogPg;